<template>
  <div>
    <v-container>
      <v-layout wrap class="pt-4" justify-end>
        <v-flex xs12 sm6 class="text-sm-right text-xs-right">
          <v-btn dark outline color="primary" @click="handleExportXlsx" :loading="loading">
            <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
          </v-btn>
          <v-btn depressed color="primary" @click="showSearch = true" class="ma-0 mr-1">
            Filter/Search
          </v-btn>
        </v-flex>
      </v-layout>
      <v-data-table
        hide-actions
        :loading="loading"
        :headers="headers"
        :items="branchData"
        :pagination.sync="pagination"
        class="elevation-1 mt-3"
      >
        <template slot="headerCell" slot-scope="props">
          <HeaderTableWithSort
            :headers="props.header"
            :sortBy.sync="sortBy"
            :orderBy.sync="orderBy"
            @onSort="handleChangeSort"
          ></HeaderTableWithSort>
        </template>
        <template v-slot:items="props">
          <tr>
            <td>{{ props.item.id }}</td>
            <td class="text-center">
              <div
                :class="{
                  register: props.item.status == 'register',
                  pending: props.item.status == 'pending',
                  waiting: props.item.status == 'waiting',
                  approve: props.item.status == 'approve',
                  reject: props.item.status == 'reject'
                }"
              >
                {{ mapStatus[props.item.status] }}
              </div>
            </td>
            <td class="primary-color cursor-pointer" @click="clickShowLog(props.item)">
              {{ props.item.full_name || '-' }}
            </td>
            <td>{{ props.item.phone_number || '-' }}</td>
            <td>{{ props.item.branch_name || '-' }}</td>
            <td>{{ dateEx(props.item.start_time) }}</td>
            <td>{{ dateEx(props.item.end_time) }}</td>
            <td>{{ props.item.supervisor || '-' }}</td>
            <td>{{ props.item.approve_by || '-' }}</td>
          </tr>
        </template>
      </v-data-table>
      <div class="mt-2">
        <v-pagination
          :total-visible="6"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>
      </div>
    </v-container>
    <v-dialog v-model="showSearch" persistent width="800px">
      <SearchRequestDialog @close="handleCloseSearch" @onSearch="onSearch"></SearchRequestDialog>
    </v-dialog>
    <v-dialog
      v-if="activeMember && activeMember.member_id"
      v-model="showLog"
      persistent
      width="800px"
    >
      <RequestLogDialog @close="handleCloseLog" v-model="activeMember"></RequestLogDialog>
    </v-dialog>
  </div>
</template>

<script>
import yasaleAcApi from '@/api/yasale-ac'
import { mapGetters } from 'vuex'
import SearchRequestDialog from './SearchRequestDialog.vue'
import RequestLogDialog from './RequestLogDialog.vue'
import * as XLSX from 'xlsx'
import moment from 'moment'
import HeaderTableWithSort from '@/components/elements/HeaderTableWithSort.vue'
import { ORDER_BY } from '@/constants/orderBy.js'

export default {
  components: {
    SearchRequestDialog,
    RequestLogDialog,
    HeaderTableWithSort
  },
  data() {
    return {
      activeMember: null,
      limit: 10,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      showSearch: false,
      showLog: false,
      loading: false,
      filter: {},
      branchData: [],
      mapStatus: {
        register: 'รอตรวจสอบข้อมูลช่าง',
        pending: 'รอพิจารณา',
        approve: 'อนุมัติ',
        reject: 'ไม่อนุมัติ',
        waiting: 'รอรหัส PIN'
      },
      headers: [
        { text: 'คำขอหมายเลข', value: 'id', customSort: true, sortable: false },
        { text: 'สถานะคำขอ', value: 'status', customSort: true, sortable: false },
        { text: 'ชื่อช่าง', value: 'full_name', customSort: true, sortable: false },
        { text: 'เบอร์โทร', value: 'phone_number', customSort: false, sortable: false },
        { text: 'ชื่อศูนย์', value: 'branch_name', customSort: true, sortable: false },
        { text: 'วันและเวลาที่เข้า', value: 'start_time', customSort: true, sortable: false },
        { text: 'วันและเวลาที่ออก', value: 'end_time', customSort: true, sortable: false },
        { text: 'หัวหน้าศูนย์', value: 'supervisor', customSort: false, sortable: false },
        { text: 'ผู้อนุมัติ', value: 'approve_by', customSort: false, sortable: false }
      ],
      sortBy: 'id',
      orderBy: ORDER_BY.DESC
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  async mounted() {
    await this.handleGetRequest()
  },
  methods: {
    clickShowLog(data) {
      this.activeMember = data
      this.showLog = true
    },
    async handleGetRequest() {
      const vm = this
      try {
        const response = await vm.getRequest()
        if (response) {
          vm.branchData = response.data
          vm.total = response.total
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    async getRequest() {
      const vm = this
      return new Promise(async (resolve, reject) => {
        const limit = vm.isExport ? vm.total : vm.limit
        let data = {
          page_id: vm.selectedBot.pageid,
          limit: limit,
          offset: vm.offset,
          sort_by: vm.sortBy,
          order_by: vm.orderBy,
          ...this.filter
        }
        vm.loading = true
        const response = await yasaleAcApi.getRequest({
          config: {
            params: data
          }
        })

        vm.loading = false
        if (response && response.status === 200) {
          resolve(response.data)
        } else {
          reject(null)
        }
      })
    },
    async handleImport(item) {
      const vm = this
      try {
        const data = {
          page_id: vm.selectedBot.pageid,
          data: item[0]
        }

        vm.importLoading = true
        const response = await yasaleAcApi.importBranch({ data })
        vm.importLoading = false

        if (response && response.status === 200) {
          await vm.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })
          vm.reset()
        } else {
          await vm.$swal.fire({
            text: 'ข้อมูลไม่ถูกต้อง'
          })
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    downloadImportTemplate() {
      const data = []
      const heading = [['รหัสศูนย์', 'ชื่อศูนย์', 'สาขา', 'จังหวัด']]

      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_aoa(ws, heading)
      XLSX.utils.sheet_add_json(ws, data)
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `template-import-branch.xlsx`)
    },
    async handleExportXlsx() {
      const vm = this
      vm.isExport = true
      const data = await vm.getRequest()
      const requestData = data.data
      vm.isExport = false

      if (requestData == null) return
      const requests = requestData.map((el) => {
        return {
          request_id: el.id,
          full_name: el.full_name,
          phone_number: el.phone_number,
          branch_name: el.branch_name,
          start_time: vm.dateEx(el.start_time),
          end_time: vm.dateEx(el.end_time),
          supervisor: el.supervisor,
          approve_by: el.approve_by,
          status: vm.mapStatus[el.status]
        }
      })

      const heading = [
        [
          'คำขอหมายเลข',
          'ชื่อช่าง',
          'เบอร์โทร',
          'ชื่อศูนย์',
          'วันและเวลาที่เข้า',
          'วันและเวลาที่ออก',
          'หัวหน้าศูนย์',
          'ผู้อนุมัติ',
          'สถานะคำขอ'
        ]
      ]

      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_aoa(ws, heading)
      XLSX.utils.sheet_add_json(ws, requests, { origin: 'A2', skipHeader: true })
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `yasale-ac-request.xlsx`)
    },
    dateEx(textDate) {
      try {
        const date = new Date(textDate)
        return moment(date).format('DD/MM/YYYY HH:mm')
      } catch (error) {
        return ''
      }
    },
    handleDeleteBranch(id) {
      this.$swal
        .fire({
          icon: 'error',
          text: 'คุณต้องการลบใช่หรือไม่',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง'
        })
        .then((result) => {
          if (result.value) {
            this.deleteBranch(id)
          }
        })
    },
    async deleteBranch(id) {
      const vm = this
      try {
        let data = {
          page_id: vm.selectedBot.pageid,
          id: id
        }
        const response = await yasaleAcApi.deleteBranch({ data: data })
        if (response && response.status === 200) {
          await this.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })
          vm.handleGetRequest()
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    onSearch(payload) {
      this.filter = { ...payload }
      this.reset()
      this.handleCloseSearch()
    },
    handleCloseSearch() {
      this.showSearch = false
    },
    handleCloseLog() {
      this.activeMember = null
      this.showLog = false
    },
    changePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit

        vm.handleGetRequest()
      }
    },
    reset() {
      this.offset = 0
      this.pagetmp = 1
      this.pageNumber = 1
      this.handleGetRequest()
    },
    handleChangeSort() {
      this.reset()
    }
  }
}
</script>

<style lang="scss" scoped>
.register {
  width: max-content;
  background-color: #f4953d;
  padding: 5px 10px;
  border: 1px solid transparent;
  border-radius: 17px;
  color: white;
}
.pending {
  width: max-content;
  background-color: #f4c13d;
  padding: 5px 10px;
  border: 1px solid transparent;
  border-radius: 17px;
  color: white;
}
.waiting {
  width: max-content;
  background-color: #03a9f4;
  padding: 5px 10px;
  border: 1px solid transparent;
  color: #fff;
  border-radius: 17px;
}
.approve {
  width: max-content;
  background-color: #05c519;
  padding: 5px 10px;
  border: 1px solid transparent;
  color: white;
  border-radius: 17px;
}
.reject {
  width: max-content;
  background-color: #e12005;
  padding: 5px 10px;
  border: 1px solid transparent;
  color: white;
  border-radius: 17px;
}
tr > td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/YasaleAc/Permission.vue